import { render, staticRenderFns } from "./ChargeCategoryConfig.vue?vue&type=template&id=a9fc3b38&scoped=true"
import script from "./ChargeCategoryConfig.vue?vue&type=script&lang=js"
export * from "./ChargeCategoryConfig.vue?vue&type=script&lang=js"
import style0 from "./ChargeCategoryConfig.vue?vue&type=style&index=0&id=a9fc3b38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9fc3b38",
  null
  
)

export default component.exports